var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"dashboard"},[_c('Loading',{attrs:{"loading":_vm.loading}}),_c('dash-navbar'),_c('div',{staticClass:"bg-stars"},[_c('BackgroundStars'),_c('MainOverview')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }